(function () {
  var surveyForm = document.getElementById('survey-form');
  if (!surveyForm) return;

  surveyForm.addEventListener('submit', function (e) {
    e.preventDefault();

    var gasUrl = surveyForm.dataset.gasUrl;
    var hasAnyAnswer =
      surveyForm.querySelectorAll('input[name="q1"]:checked').length > 0 ||
      surveyForm.querySelectorAll('input[name="q2"]:checked').length > 0 ||
      surveyForm.querySelectorAll('input[name="q3"]:checked').length > 0;

    if (gasUrl && hasAnyAnswer) {
      var params = new URLSearchParams();
      new FormData(surveyForm).forEach(function (value, key) {
        if (key === 'utf8' || key === 'id' || key === 'quantity' || key === 'selling_plan' || key === 'return_to') {
          return;
        }
        params.append(key, value);
      });

      // 送信だけ行い、完了は待たない（keepalive でページ遷移後も届く）
      fetch(gasUrl, {
        method: 'POST',
        body: params,
        keepalive: true,
        mode: 'no-cors',
      });
    }

    surveyForm.submit();
  });
})();
